export const States = {
  INITIAL: "Initial",
  VEHICLE: "Vehicle",
  DEALER: "Dealer",
  OPERATIONS: "RepairOperations",
  APPOINTMENT: "Availability",
  CUSTOMER: "Customer",
  REVIEW: "BookingDetails",
  COMPLETE: "Complete",
  TIMEOUT: "Timeout",
};

export const Actions = {
  Reset: "Reset",
  Start: "Start",
  SetVehicle: "SetVehicle",
  SetDealer: "SetDealer",
  SetOperations: "SetOperations",
  SetAppointment: "SetAppointment",
  SetCustomer: "SetCustomer",
  Confirm: "BookingCreated",
  Timeout: "Timeout",
  Back: "BACK",
  SessionImport: "SessionImport",
};

export const HASH_ORDER = [
  "#vehicle",
  "#dealer",
  "#repairoperations",
  "#availability",
  "#customer",
  "#bookingdetails",
];

export const initialState = {
  state: States.INITIAL,
};

/*
@startuml

(*) --> [New customer] "Vehicle"
"Vehicle" --> "Dealer"
"Dealer" --> "Operations"
"Operations" --> "Appointment"
"Appointment" --> [New customer] "Customer"
"Customer" --> "Review"
"Review" --> (*)

(*) --> [Existent customer] "Dealer"
"Appointment" --> [Existent customer] "Review"

@enduml
*/

export const reducer = (state, action) => {
  switch (action.type) {
    case Actions.SessionImport:
      return {
        ...action.payload,
      };

    case Actions.Timeout:
      return {
        ...state,
        state: States.TIMEOUT,
        internalStartTimestamp: null,
      };

    case Actions.Reset:
      return {
        ...initialState,
        internalStartTimestamp: Date.now(),
      };

    case Actions.Start:
      return {
        ...state,
        ...action.payload,
        state: action.payload.existentCustomer ? States.DEALER : States.VEHICLE,
      };

    case Actions.SetVehicle:
      return {
        ...state,
        vehicle: action.payload,
        state: States.DEALER,
      };

    case Actions.SetDealer:
      return {
        ...state,
        dealer: action.payload,
        state: States.OPERATIONS,
      };

    case Actions.SetOperations:
      return {
        ...state,
        repairOperations: action.payload.operations,
        additionalRepairOperations: action.payload.comments,
        state: States.APPOINTMENT,
      };

    case Actions.SetAppointment:
      return {
        ...state,
        availability: action.payload,
        state: state.existentCustomer ? States.REVIEW : States.CUSTOMER,
      };

    case Actions.SetCustomer:
      return {
        ...state,
        customer: action.payload,
        state: States.REVIEW,
      };

    case Actions.Confirm:
      return {
        ...state,
        ...action.payload,
        state: States.COMPLETE,
      };

    case Actions.Back:
      switch (action.payload.to) {
        case "#vehicle":
          return {
            ...state,
            state: States.VEHICLE,
          };
        case "#dealer":
          return {
            ...state,
            state: States.DEALER,
          };
        case "#repairoperations":
          return {
            ...state,
            state: States.OPERATIONS,
          };
        case "#availability":
          return {
            ...state,
            state: States.APPOINTMENT,
          };
        case "#customer":
          return {
            ...state,
            state: States.CUSTOMER,
          };
        default:
          return {
            ...state,
            state: state.state,
          };
      }
    default:
      return state;
  }
};
